import Component from './widget_preview_grid.vue'
export default Component
